<template>
  <div v-if="show" id="form_btn_container" class="text-[var(--text)] min-w-[40%] gap-2 p-4 bg-[var(--fundoForm)] rounded-[10px] bg-opacity-[0.55] flex flex-col fixed-half">
    <div class="w-full flex justify-between">
      <h3 class="text-[var(--titulo)] text-[18px] font-bold">{{ form_title }}</h3>
      <div class="flex items-center gap-2">
        <HistoricoObjetoButton
          model-name="Armazem"
          :objeto-id="form_data.id"
          modelo-label="Armazém"
          variant="bare"
          icon-only
        />
        <AppButton
          style="color: var(--icon);"
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="23"
          :height="23"
        />
      </div>
    </div>
    <div class="form_container">
      <div id="left_form" class="left_form">
        <div class="grid grid-cols-[auto_1fr] gap 2 mr-6">
          <div class="flex gap-2 items-center">
            <label for="nome" class="min-w-[55px] font-bold">Armazem:</label>
          </div>
          <div class="flex gap-2 items-center">
            <textarea
              :disabled="form_data.status == 'desativado' || !create_btn"
              type="text"
              v-model="form_data.armazem"
              placeholder="Armazem"
              class="w-full text-[20px] p-1 rounded-[5px]"
              :class="{ 'input-required': create_btn && !form_data.armazem }"
            ></textarea>
          </div>
          <div class="flex gap-2 items-center">
          <label for="descricao" class="min-w-[55px] font-bold mr-6">Descricao:</label>
          </div>
          <div class="flex gap-2 items-center">
          <textarea :disabled="form_data.status == 'desativado'" type="text" v-model="form_data.descricao"
            class="w-full p-2 rounded-lg"
            :class="{ 'input-required': !form_data.descricao }"
            placeholder="Descrição"></textarea>
          </div>
        </div>

        <div class="data_set_class">
          <div class="grid grid-cols-[auto_1fr_min-content] gap-y-1 mr-6 items-center">
            <div class="ser_data">
              <label class="min-w-[76px] font-bold">Tipo Armazém:</label>
            </div>
            <div class="ser_data" :style="{ color: set_data.tipo_armazem.id === 0 ? 'var(--obrigatorio)' : 'var(--icon)' }">
              {{ set_data.tipo_armazem.nome || "Não Atribuído" }}
            </div>
            <div class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' || !create_btn ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado' || !create_btn"
                @click="selectTable('tipo')">
                <Icon class="edit-icon" icon="lucide:warehouse" />
              </button>
            </div>

            <div class="ser_data">
              <label class="min-w-[76px] font-bold">Zona:</label>
            </div>
            <div class="ser_data" :style="{ color: set_data.zona.id === 0 ? 'var(--obrigatorio)' : 'var(--icon)' }">
              {{ set_data.zona.nome || "Não Atribuído" }}
            </div>
            <div class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' || !create_btn? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado' || !create_btn"
                @click="selectTable('zona')">
                <Icon class="edit-icon" icon="lucide:warehouse" />
              </button>
            </div>

            <div v-if=!create_btn class="ser_data">
              <label class="min-w-[76px] font-bold">Morada:</label>
            </div>
            <div v-if=!create_btn class="ser_data"></div>
            <div v-if=!create_btn class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="selectTable('mapa')">
                <Icon class="edit-icon" icon="lucide:map" />
              </button>
            </div>

            <div v-if=!create_btn class="ser_data">
              <label class="min-w-[76px] font-bold">Utilizadores:</label>
            </div>
            <div v-if=!create_btn class="ser_data"></div>
            <div v-if=!create_btn class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="selectTable('utilizador')">
                <Icon class="edit-icon" icon="lucide:user-cog" />
              </button>
            </div>

            <div v-if=!create_btn class="ser_data">
              <label class="min-w-[76px] font-bold">Contactos:</label>
            </div>
            <div v-if=!create_btn class="ser_data"></div>
            <div v-if=!create_btn class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado' "
                @click="selectTable('contacto')">
                <Icon class="edit-icon" icon="lucide:mail" />
              </button>
            </div>

            <div v-if=!create_btn class="ser_data">
              <label class="min-w-[76px] font-bold">Stock:</label>
            </div>
            <div v-if=!create_btn class="ser_data"></div>
            <div v-if=!create_btn class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="selectTable('stock')">
                <Icon class="edit-icon" icon="lucide:box" />
              </button>
            </div>

            <div v-if=!create_btn class="ser_data">
              <label class="min-w-[76px] font-bold">Carrega Artigos:</label>
            </div>
            <div v-if=!create_btn class="ser_data"></div>
            <div v-if=!create_btn class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado' "
                @click="selectTable('novo_artigo')">
                <Icon class="edit-icon" icon="lucide:box" />
              </button>
            </div>
            
            <div v-if=!create_btn class="ser_data">
              <label class="min-w-[76px] font-bold">Transferir Artigos:</label>
            </div>
            <div v-if=!create_btn class="ser_data"></div>
            <div v-if=!create_btn class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado'  ? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="selectTable('Transferir_Artigos')">
                <Icon class="edit-icon" icon="lucide:send" />
              </button>
            </div>

            <div v-if=!create_btn class="ser_data">
              <label class="min-w-[76px] font-bold">Transferir Ordem De Serviço:</label>
            </div>
            <div v-if=!create_btn class="ser_data"></div>
            <div v-if=!create_btn class="ser_data w-[4px]">
              <button
                :style="{color: form_data.status == 'desativado'? 'var(--desativado)' : 'var(--icon)',}"
                :disabled="form_data.status == 'desativado'"
                @click="selectTable('Transferir_OS')">
                <Icon class="edit-icon" icon="lucide:truck" />
              </button>
            </div>
            <div v-if=!create_btn class="ser_data">
              <label class="min-w-[76px] font-bold">Movimentos Pendentes:</label>
            </div>
            <div v-if=!create_btn class="ser_data"></div>
            <div v-if=!create_btn class="ser_data" colspan="2">
              <span 
                class="px-2 py-1 rounded-full text-xs font-medium"
                :class="(form_data.movimentos || 0) > 0 
                  ? 'bg-red-600/80 text-white cursor-pointer hover:bg-red-500/60' 
                  : 'bg-green-500/20 text-green-300 cursor-default'"
                @click="(form_data.movimentos || 0) > 0 && selectTable('Movimentos_Pendentes')"
              >
                {{ form_data.movimentos || 0 }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div id="right_form" class="right_form">
        <div class="img_signature_container">
          <div class="img_btn_container">
            <div class="img_container">
              <img id="armazem_img" :src="formData.foto" alt="armazem image" />
            </div>
            <div style="margin-top: 0.5rem">
              <label for="input-file">
                <i
                  class="fa-solid fa-circle-plus fa-xl"
                  :style="{
                    color:
                      form_data.status == 'desativado' ? '#7B7B99' : 'var(--icon)',
                    cursor:
                      form_data.status == 'desativado'
                        ? 'not-allowed'
                        : 'pointer',
                  }"
                ></i>
              </label>
              <input
                :disabled="form_data.status == 'desativado'"
                type="file"
                accept="image/jpeg, image/png, image/jpg"
                id="input-file"
                @change="upload_img"
                hidden
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; gap: 0.5rem; padding: 1rem">
      <button
        v-if="create_btn && this.validPermission('A0020')"
        class="btn"
        @click="showConfirm($event, 'create')"
        :font_size="14"
      >
        Criar
      </button>
      <button
        v-if="!create_btn && this.validPermission('A0020') && form_data.status == 'ativo'"
        class="btn"
        :style="{
          backgroundColor:
            form_data.status !== 'ativo' ? 'var(--desativado)' : 'rgb(0, 102, 152)',
        }"
        @click="showConfirm($event, 'update')"
        :font_size="14"
      >
        Atualizar
      </button>
      <button
        v-if="!create_btn && this.validPermission('A0019') && form_data.status =='ativo'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'red' }" 
        @click="showConfirm($event, 'disable')"
        >Desativar</button>
      <button
        v-if="!create_btn && this.validPermission('A0019') && form_data.status =='desativado'"
        class="btn"
        :font_size="14"
        :style="{ backgroundColor: 'green' }" 
        @click="showConfirm($event, 'disable')">Ativar</button>     

      <ConfirmPopUp ref="myConfirm" @accept="onAccept" />
    </div>
  </div>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import ConfirmPopUp from "@/components/modals/MyConfirmPopUp.vue";
import { toast } from "vue3-toastify";
import permissionMixin from "@/permissionMixin.js";
import HistoricoObjetoButton from "@/components/historico/HistoricoObjetoButton.vue";

export default {
  mixins: [permissionMixin],
  name: "AppArmazemForm",
  components: {
    AppButton,
    ConfirmPopUp,
    HistoricoObjetoButton,
  },
  props: {
    form_data: {
      type: Object,
      default: () => ({}),
    },
    set_data: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    form_title: {
      type: String,
      default: () => "No Title",
    },
    create_btn: {
      type: Boolean,
      default: () => false,
    },
    update_visibility: {
      type: Boolean,
      default: () => false,
    },
    disable_visibility: {
      type: Boolean,
      default: () => false,
    },
  },
  created() {
  console.log("Dados recebidos no filho:", this.form_data, this.set_data);
},

  data() {
    return {
      formData: {},
      baseURl: process.env.VUE_APP_URL_BASE,
      emit_type: "",
    };
  },
  methods: {
    
    isArmazemValid() {
      return (
        this.set_data.armazem &&
        this.set_data.armazem.tipo &&
        this.set_data.armazem.tipo.nome
      );
    },

    isArmazemOficinaOrViatura() {
      return (
        this.set_data?.tipo_armazem?.nome === "Armazem Viatura" ||
        this.set_data?.tipo_armazem?.nome === "Armazem-Viatura-Oficina"
      );
    },
    showConfirm(event, message) {
      this.emit_type = message;
      this.$refs.myConfirm.show(event.target);
    },
    onAccept() {
      if (this.emit_type == "create") {
        this.create();
      } else if (this.emit_type == "update") {
        console.log("to update");
        this.update();
      } else if (this.emit_type == "disable") {
        this.disable();
      } else {
        this.$emit("show_table", this.emit_type);
      }

      console.log("Confirmed!");
    },

    selectTable(name) {
      // Logic to handle selecting armazem
      this.$emit("show_table", name);
    },

    triggerAction(action) {
      console.log('triggerAction acionado:', action);
      this.$emit('triggerAction', action)
  },

    async upload_img(event) {
      console.log("inside upload method");
      const file = event.target.files[0]; // Get the selected file
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = document.getElementById("armazem_img");
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);

        const formData = new FormData();
        formData.append("foto", file);
        this.formData.newFoto = formData;
      }
    },

    create() {
      if (!this.isValidForm()) {
        return;
      }
        // const formData = this.getFormData();
        // console.log("Enviando dados para criação:", formData);
        // this.$emit("create", formData);
      

      const formData = this.getFormData();
      console.log("create formdata:", formData);
      this.$emit("create", formData);
    },
    update() {
      if (!this.isValidForm()) {
        return;
      }
      const formData = this.getFormData();
      //console.log("update formdata:", formData)
      this.$emit("update", formData);
    },
    disable() {
      //if(!this.isValidForm()) return
      const formData = this.getFormData();
      //console.log("disable formdata:", formData)
      this.$emit("disable", formData);
    },
    isValidForm() {
      if (
        !this.formData.armazem ||
        !this.formData.descricao ||
        //J.. para evitar erro se set_data.tipo_armazem estiver indefinido:
        (this.set_data.tipo_armazem?.id || 0) === 0 ||
        // this.set_data.tipo_armazem.id == 0 ||
        this.set_data.zona.id == 0
      ) {
        toast("Preencha todos os campos obrigatórios!", {
          theme: "auto",
          type: "warning",
          position: "top-center",
          autoClose: 1000,
        });
        return false;
      }
      return true;
    },

    getFormData() {
      const formDataObject = {
        ...this.formData,
        ...this.set_data,
      };
      console.log("form data:", this.formData);
      console.log("form data:", this.set_Data);

      return formDataObject;
    },
    close() {
      this.$emit("close");
    },
    updateFormData() {
      this.formData = { ...this.form_data };
      // console.log("form data:", this.formData)
    },
    isEmptyField(field) {
      if (["armazem", "descricao"].includes(field)) {
        return (
          this.formData[field] === "" || Array.isArray(this.formData[field])
        );
      }

      return false;
    },
  },

  watch: {
    form_data: {
      handler(newVal) {
        console.log("show_form atualizado no filho:", newVal);
      this.formData = { ...newVal };
      console.log("Formulário atualizado no filho:", this.formData);
    },
    //J..
      // handler() {
      //   this.updateFormData();
      //   //this.isEmptyContactField()
      // },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>

.form_container {
  display: flex;
  gap: 1px;
  padding: 1px;
  border-radius: 10px;
}

.left_form {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

h3 {
  display: flex;
  padding: 0.4rem;
  color: var(--label);
}

label {
  display: block;
  color: var(--label);
  /* font-weight: bold; */
  font-size: 14px;
  padding: 0.2rem;
  min-width: 1rem;
  text-wrap: nowrap;
}

input[type="text"],
select {
  padding: 0.3rem;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid var(--glass-border);
}

.btn {
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background-color: var(--button);
  color: var(--label);
  border: none;
  border-radius: 10px;
  padding: 0.5rem 0.8rem;
  cursor: pointer;
  gap: 0.5rem;
}


.input_field.textarea {
  width: 200px;
  height: 80px;
  color: var(--text);
}

.data_set_class {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px;
  border-radius: 10px;
  background-color: var(--fundoComponente);
}

.data_set {
  font-size: 14px;
  color: var(--label);
  display: flex;
  gap: 0.3rem;
}

.right_form {
  display: flex;
  flex-direction: column;
  padding: 2px;
  align-items: center;
}

.img_container {
  margin-top: -0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.img_btn_container {
  display: flex;
  gap: 0.5rem;
}

.img_container {
  display: flex;
  width: 150px;
  aspect-ratio: 1/1;
  height: auto;
}

.img_container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.right_input_container {
  margin-top: 4px;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 10px;
}


.set_data_container {
  display: flex;
  flex-direction: column; /* Organiza os itens verticalmente */
  gap: 1rem; /* Espaçamento entre os campos */
  background-color: var(--fundoComponente); /* Mesma cor de fundo */
  padding: 1rem; /* Espaçamento interno */
  border-radius: 10px; /* Bordas arredondadas */
  max-width: 100%; /* Para garantir que não ultrapasse a largura disponível */
}

.input_container {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  /* Adjust spacing between label and input field */
}

.input_label {
  width: 100px;
  font-size: 14px;
}

.input_field {
  flex: 1;
  /* Take remaining space */
  padding: 0.3rem;
  font-size: 10px;
  border-radius: 5px;
  border: 1px solid var(--fundoApp);
}

.ser_data {
  display: flex;
  align-items: center; /* Alinha o texto verticalmente ao centro */
  justify-content: space-between; /* Espaça os rótulos e valores */
  gap: 0.5rem; /* Espaçamento entre os itens */
}

.ser_data label {
  min-width: 120px; /* Define uma largura mínima fixa para os rótulos */
  text-align: left; /* Alinha os rótulos à esquerda */
  font-weight: bold; /* Destaca os rótulos */
  color: var(--label); /* Cor branca para os rótulos */
}


.text-white {
  color: var(--label);
}

.text-black {
  color: var(--text);
}

</style>
